import { ChevronLeft, ChevronRight } from 'lucide-react';

export interface ListPagerProps {
  page: number;
  pageCount: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}

/** "51–100 of 120" with previous / next; shows nothing while everything fits on one page. */
export function ListPager({ page, pageCount, pageSize, total, onPageChange }: ListPagerProps) {
  if (pageCount <= 1) return null;
  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);
  const button =
    'flex items-center justify-center min-h-11 min-w-11 sm:min-h-0 sm:min-w-0 p-1.5 rounded-md text-gray-600 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent';
  return (
    <nav
      aria-label="Pages"
      className="flex items-center justify-end gap-2 px-4 py-2 border-t border-gray-200 text-sm text-gray-600"
    >
      <span>
        {first}–{last} of {total}
      </span>
      <button
        type="button"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
        className={button}
        aria-label="Previous page"
      >
        <ChevronLeft size={16} />
      </button>
      <button
        type="button"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= pageCount}
        className={button}
        aria-label="Next page"
      >
        <ChevronRight size={16} />
      </button>
    </nav>
  );
}
